import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_GRADIENT_STOPS = [
  { offset: '0%', color: '#09F' },
  { offset: '60%', color: '#A033FF' },
  { offset: '90%', color: '#FF5280' },
  { offset: '100%', color: '#FF7061' }
];

const Messenger = ({ gradientStops = DEFAULT_GRADIENT_STOPS, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={31} height={31} fill="none" {...props}>
    <defs>
      <radialGradient
        id="messenger-gradient"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(5.525 30.515) scale(32.9991)"
        gradientUnits="userSpaceOnUse"
      >
        {gradientStops.map((stop, index) => (
          <stop key={`${stop.offset}-${stop.color}-${index}`} offset={stop.offset} stopColor={stop.color} />
        ))}
      </radialGradient>
    </defs>
    <path
      fill="url(#messenger-gradient)"
      d="M15.5.516C7.05.516.5 6.707.5 15.066c0 4.372 1.792 8.152 4.71 10.762.244.217.394.525.401.855l.083 2.67a1.2 1.2 0 0 0 1.683 1.061l2.978-1.312c.251-.113.536-.132.802-.06 1.369.375 2.824.577 4.343.577 8.448 0 15-6.191 15-14.55 0-8.358-6.552-14.553-15-14.553Z"
    />
    <path
      fill="#fff"
      d="m6.492 19.322 4.407-6.99a2.249 2.249 0 0 1 3.254-.6l3.507 2.629a.9.9 0 0 0 1.083-.004l4.733-3.592c.63-.48 1.455.277 1.035.948L20.1 18.7a2.25 2.25 0 0 1-3.255.6l-3.506-2.628a.9.9 0 0 0-1.084.003l-4.732 3.593c-.63.48-1.455-.274-1.032-.945Z"
    />
  </svg>
);

Messenger.propTypes = {
  gradientStops: PropTypes.arrayOf(
    PropTypes.shape({
      offset: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    })
  )
};

export default Messenger;
